import { getServiceProvider } from '@takeshape/service-providers';
import { avatars, logos } from '../assets/index.js';
import { createServiceProvider } from '../util/index.js';

export default createServiceProvider({
  ...getServiceProvider('elasticpath'),
  hasConnectionStatus: false,
  titleToNamespace: true,
  avatarPath: avatars.elasticpath,
  logoPath: logos.elasticpath
});
